module.exports = __webpack_public_path__ + "static/one-kings-lane-7ed8e849427dc2181213dd74a6edd318.svg";